import { SBaseDisplay, SDate } from '@summit/core';

import { SummitFormattedText } from '@summit/models';
import { EboNameObject } from '../../base-classes/ebo-name-object';
import { Division } from '../division';
import { DivisionLegWageSetRule } from './division-leg-wage-set-rule';

export class DivisionLegWageSet extends EboNameObject implements SBaseDisplay {
  divisionID: string;
  division: Division;

  rules: DivisionLegWageSetRule[];

  static sort(n1: DivisionLegWageSetRule, n2: DivisionLegWageSetRule) {
    //console.log(`comparing ${n1.defaultSort} to ${n2.defaultSort}`);
    return n1.defaultSort > n2.defaultSort ? 1 : -1;
  }

  constructor(jsonData: Partial<DivisionLegWageSet>) {
    super(jsonData);
    //console.log(`Building Division Parameter: ${jsonData.dollyNumbers}`, jsonData);
    if (jsonData) {
      if (jsonData.division) this.division = new Division(jsonData.division);
      if (jsonData.rules)
        this.rules = jsonData.rules.map((data) => new DivisionLegWageSetRule(data)).sort(DivisionLegWageSet.sort);
    }
    this.rules ??= [];
  }
  toShortString(): string {
    return this.name;
  }

  get defaultSort() {
    return `${this.division ? this.division.name : '!!!!!!'}-${this.name}`;
  }

  getNextRuleOrder(): number {
    let maxRuleNum = 0;
    if (this.rules && this.rules.length > 0) {
      maxRuleNum = this.rules
        .map((s) => s.ruleOrder)
        .reduce(function (a, b) {
          return Math.max(a, b);
        });
    }
    return (maxRuleNum ?? 0) + 1;
  }

  private _rulesSummary: SummitFormattedText;
  get rulesSummary(): SummitFormattedText {
    if (this._rulesSummary === undefined) {
      this._rulesSummary = new SummitFormattedText();
      this.rules
        .filter((rule) => !rule.endTime || !rule.endTime.isSameOrBefore(SDate.getNormalized()))
        .forEach((rule) => {
          this._rulesSummary.AddKeyValues(
            `#${rule.ruleOrder}: ${rule.applicableEmployee}`,
            rule.comment ? `#${rule.ruleOrder} - ${rule.comment}` : null
          );
          this._rulesSummary.AddLine(rule.toShortString());
        });
    }
    return this._rulesSummary;
  }
}
